import { QRCodeSVG } from 'qrcode.react';
import { useRef } from 'react';

interface QRCodeProps {
  value: string;
  size?: number;
  onDataUrl?: (dataUrl: string) => void;
}

export default function QRCode({ value, size = 200, onDataUrl }: QRCodeProps) {
  const qrRef = useRef<HTMLDivElement>(null);

  const handleLoad = () => {
    if (qrRef.current && onDataUrl) {
      const svg = qrRef.current.querySelector('svg');
      if (svg) {
        const svgData = new XMLSerializer().serializeToString(svg);
        const dataUrl = `data:image/svg+xml;base64,${btoa(svgData)}`;
        onDataUrl(dataUrl);
      }
    }
  };

  return (
    <div ref={qrRef} className="rounded-lg bg-white p-4">
      <QRCodeSVG
        value={value}
        size={size}
        level="H"
        includeMargin
        className="rounded-lg"
        onLoad={handleLoad}
      />
    </div>
  );
}
